export default class BundleSlot extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-container]');
    this.handleBundleUpdate = this.handleBundleUpdate.bind(this);
  }

  initEventListeners() {
    document.addEventListener('bundleUpdated', this.handleBundleUpdate)
  }

  handleBundleUpdate(event) {
    const product = event.detail.products[this.getAttribute('index')];
    if (product) {
      this.classList.add('added');
      this.container.innerHTML = `
        <img 
          class='absolute inset-0 object-cover rounded-xl' 
          src="${product.images[0].src}" alt="${product.images[0].alt}"/>
      `;
    } else {
      this.classList.remove('added');
      this.container.innerHTML = '';
    }
  }

  connectedCallback() {
    this.initEventListeners();
  }

  disconnectedCallback() {
    document.removeEventListener('bundleUpdated', this.handleBundleUpdate)
  }
}
